import { NgModule } from '@angular/core';
import { RequiredFieldValidatorDirective } from './directives/required-field-validator.directive';
import { DawaAddressValidatorDirective } from './directives/dawa-address-validator.directive';
import { CheckboxValidatorDirective } from './directives/checkbox-validator.directive';
import { EmailValidatorDirective } from './directives/email-validator.directive';
import { DateValidatorDirective } from './directives/date-validator.directive';
import { CprValidatorDirective } from './directives/cpr-validator.directive';
import { PhoneValidatorDirective } from './directives/phone-validator.directive';
import { BankAccountValidatorDirective } from './directives/bank-account-validator.directive';
import { ClassSelectionValidatorDirective } from './directives/class-selection-validator.directive';

@NgModule
    ({
        imports: [
        ],
        declarations: [
            BankAccountValidatorDirective,
            CheckboxValidatorDirective,
            ClassSelectionValidatorDirective,
            CprValidatorDirective,
            DateValidatorDirective,
            DawaAddressValidatorDirective,
            EmailValidatorDirective,
            PhoneValidatorDirective,
            RequiredFieldValidatorDirective
        ],
        providers: [
        ],
        exports: [
            BankAccountValidatorDirective,
            CheckboxValidatorDirective,
            ClassSelectionValidatorDirective,
            CprValidatorDirective,
            DateValidatorDirective,
            DawaAddressValidatorDirective,
            EmailValidatorDirective,
            PhoneValidatorDirective,
            RequiredFieldValidatorDirective
        ]
    })
export class ValidationModule
{ }
